import { toast } from "sonner";
import { useDesktopUi, type RightTab } from "@/desktop/ui";
import { DEFAULT_LAYOUT, useWorkspace } from "./store";

export type LayoutPreset = "default" | "focus" | "collab";

export const LAYOUT_LABELS: Record<LayoutPreset, string> = {
  default: "Padrão",
  focus: "Foco no editor",
  collab: "Colaboração",
};

/** Ids dos grupos de painéis redimensionáveis (os tamanhos ficam salvos com estes nomes). */
// h4: a barra lateral ficou mais estreita por padrão (os tamanhos salvos antes voltam ao novo padrão).
export const PANEL_GROUP_IDS = ["kompil.layout.h4", "kompil.layout.v", "kompil.layout.editors"] as const;

/**
 * Layouts prontos. Padrão: explorador, terminal e Pessoas. Foco: só o editor. Colaboração:
 * explorador e o chat do time, sem o painel inferior.
 */
export function applyLayout(preset: LayoutPreset) {
  const ws = useWorkspace.getState();
  const ui = useDesktopUi.getState();
  useWorkspace.setState({ zen: false });
  if (preset === "default") {
    useWorkspace.setState({ ...DEFAULT_LAYOUT });
    ui.set({ side: "people" });
  } else if (preset === "focus") {
    useWorkspace.setState({ panel: null, terminalOpen: false });
    ui.set({ side: null });
  } else {
    useWorkspace.setState({ panel: ws.panel ?? "files", terminalOpen: false });
    ui.set({ side: "team" });
  }
}

/** Volta ao layout padrão, inclusive os tamanhos dos painéis. */
export function resetLayout() {
  try {
    for (const id of PANEL_GROUP_IDS) {
      for (const key of Object.keys(localStorage)) {
        if (key.startsWith(`react-resizable-panels:${id}`)) localStorage.removeItem(key);
      }
    }
  } catch {
    // sem armazenamento: só o estado da sessão volta ao padrão
  }
  applyLayout("default");
  useWorkspace.setState((s) => ({ layoutVersion: s.layoutVersion + 1 }));
  toast("Layout padrão restaurado.");
}

/** Lateral direita: fecha lembrando a aba, ou reabre a última (Pessoas na primeira vez). */
let lastSide: RightTab = "people";
export function toggleRightSide() {
  const ui = useDesktopUi.getState();
  if (ui.side) {
    lastSide = ui.side;
    ui.set({ side: null });
  } else ui.set({ side: lastSide });
}
